import SupportMessages from '@commons/supportChat/messages'
import { useSelector } from 'react-redux'

const DoctorTalkToSupportPage = () => {
  const { data: user } = useSelector((state: any) => state.user)
  return (
    <SupportMessages
      receiver={{
        id: '0',
        name: 'Supachar Support',
        avatar: '',
      }}
      sender={{
        id: user?.id,
        name: user?.name,
        avatar: user?.avatar,
      }}
    />
  )
}

export default DoctorTalkToSupportPage
